import axios from "axios";
import { endAuthSession } from "./authSession";

const API_BASE_URL = import.meta.env.VITE_API_URL || "https://api.lastiqo.com/api";

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: { "Content-Type": "application/json" },
  timeout: 10000,
});

const forceLoginRedirect = (message) => {
  endAuthSession("expired");
  return Promise.reject(new Error(message));
};

// İstek interceptor — her istekte JWT token ekle
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("pl_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Yanıt interceptor — 401 alınırsa oturumu kapat ve login'e yönlendir
apiClient.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const status = error.response?.status;
    const isAuthenticated = localStorage.getItem("pl_auth") === "1";
    const isUnauthorized = status === 401;
    const isBackendUnavailable = [502, 503, 504].includes(status);
    const isNetworkOrTimeout =
      !error.response &&
      (error.code === "ECONNABORTED" || error.message === "Network Error" || !!error.request);

    if (isUnauthorized) {
      const apiMessage = error.response?.data?.mesaj || error.response?.data?.message;
      return forceLoginRedirect(apiMessage || "Oturum süreniz doldu. Lütfen tekrar giriş yapın.");
    }

    if (isAuthenticated && (isBackendUnavailable || isNetworkOrTimeout)) {
      return forceLoginRedirect("Sunucuya ulaşılamadı. Lütfen tekrar giriş yapın.");
    }

    const msg =
      error.response?.data?.message ||
      error.response?.data ||
      error.message ||
      "Sunucu hatası";
    console.error("[API Hatası]", msg);
    const apiError = new Error(typeof msg === "string" ? msg : JSON.stringify(msg));
    apiError.responseData = error.response?.data;
    apiError.status = error.response?.status;
    return Promise.reject(apiError);
  }
);

export default apiClient;
